const store = {
  namespaced: true,
  state: () => ({
    user: {}
  }),
  mutations: {
    set (state, user) {
      state.user = user
    }
  },
  actions: {
    set (context, user) {
      context.commit('set', user)
    }
  },
  getters: {
    user: state => {
      return state.user
    }
  }
}

export default store